// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { collection, getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAgYVcgXSJkllx1VdyHwYHPLTxCrivI8nA",
  authDomain: "emotion-tool.firebaseapp.com",
  projectId: "emotion-tool",
  storageBucket: "emotion-tool.appspot.com",
  messagingSenderId: "545325624373",
  appId: "1:545325624373:web:04c745b58335bf2fe8157c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const provider = new GoogleAuthProvider();

export {auth, db, provider}